// extracted by mini-css-extract-plugin
export default {"container":"HorizontalMenu_container__zT8r5"};